var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFire(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 22,
    viewBox: "0 0 18 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "fire"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\xEF\x81\xAD (Stroke)",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.58628 3.92741C8.76224 2.91841 7.82945 1.92101 6.82467 0.959961C2.97899 4.56809 0.298668 9.1959 0.298668 12.0196C0.298668 17.0004 4.18319 21.04 9 21.04C13.778 21.04 17.7013 17.0004 17.7013 12.0196C17.7013 9.94105 15.6814 5.62699 12.8457 2.99934C12.4901 3.32412 12.1567 3.65635 11.839 3.99603C11.4278 4.43569 11.0429 4.88783 10.6703 5.35246C10.3355 4.87659 9.97283 4.40073 9.58628 3.92741ZM12.8169 5.50573C12.5475 5.8075 12.2864 6.11887 12.0281 6.4411L10.5797 8.24746L9.24718 6.35403C8.56227 5.3808 7.7425 4.39458 6.82305 3.42366C5.53568 4.79984 4.44043 6.26749 3.62044 7.66476C2.52703 9.52792 2.03893 11.0677 2.03893 12.0196C2.03893 16.1005 5.20439 19.2997 9 19.2997C12.7617 19.2997 15.9611 16.0954 15.9611 12.0196C15.9611 11.3985 15.6082 10.0994 14.7901 8.51294C14.2566 7.47829 13.581 6.43041 12.8169 5.50573Z",
    fill: "#ACB3B8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Ellipse 147 (Stroke)",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9 16.1229C10.3308 16.1229 11.4096 15.0441 11.4096 13.7133C11.4096 12.3826 10.3308 11.3037 9 11.3037C7.66921 11.3037 6.5904 12.3826 6.5904 13.7133C6.5904 15.0441 7.66921 16.1229 9 16.1229ZM9 17.8632C11.2919 17.8632 13.1499 16.0053 13.1499 13.7133C13.1499 11.4214 11.2919 9.56348 9 9.56348C6.70809 9.56348 4.85013 11.4214 4.85013 13.7133C4.85013 16.0053 6.70809 17.8632 9 17.8632Z",
    fill: "#ACB3B8"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFire);
export default __webpack_public_path__ + "static/media/fire.5d575a674db118f89554a0439b238460.svg";
export { ForwardRef as ReactComponent };